import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CdkDragDrop, moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { GallerySelectorComponent } from '../../../layout/gallery-selector/gallery-selector.component';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { EditorModule } from '@tinymce/tinymce-angular';
import 'tinymce/tinymce.min.js';                    
import 'tinymce/icons/default/icons.min.js';
import 'tinymce/themes/silver/theme.min.js'; 

// საჭიროებისამებრ პლაგინები
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/image';
import 'tinymce/plugins/fullscreen';
import { FileManagerComponent } from 'src/app/components/layout/file-manager/file-manager.component';
import { PagesService } from 'src/app/services/pages/pages.service';
import { AdminService } from 'src/app/services/admin/admin.service';

import slugify from 'slugify';
import { MetaFormModalComponent } from "src/app/components/layout/meta-form-modal/meta-form-modal.component";
import { environment } from '../../../../../environments/environment'
import { UploadComponent } from "src/app/components/layout/file-manager/upload/upload.component";

@Component({
  selector: 'app-post-modal',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    GallerySelectorComponent,
    FileManagerComponent,
    EditorModule,
    MetaFormModalComponent,
    UploadComponent
],
  templateUrl: './post-modal.component.html',
  styleUrl: './post-modal.component.css'
})
export class PostModalComponent implements OnInit, OnChanges {
  @Input() initialData: any = null;
  @Input() isPost: boolean = false;
  @Input() isCat: boolean = false;
  @Input() menuid: number = 161
  @Output() save = new EventEmitter<any>();
  @Output() closeModal = new EventEmitter<void>();

  pageForm: FormGroup;
  selectedImage: string | null = null;
  gallery: string[] = [];
  loadSave = false;
  editingPageId: number | null = null;

  @ViewChild('fileManagerModal') fileManagerModal!: TemplateRef<any>;
  private filePickerCallback: ((url: string) => void) | null = null;
  modalRef: any;

  currentLang = 'ge'; 
  originalSlug: string = '';

  @ViewChild('metaFormModal') metaFormModal!: TemplateRef<any>;

  domain = environment.apiDomain

  @Input() selectedItems!: any[];

  isFullscreen = false;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private PagesService: PagesService,
    private ToastrService: ToastrService,
    private AdminService: AdminService
  ) {
   
    this.pageForm = this.fb.group({
      lang: ['geo'],
      page: [null],

      main_menu_page: [0],
      menu_page: [0],
      menu_id: [null],

      photogallery: [0],
      only_gallery: [0],

      slug: [''],
      title: [''],
      bold: [0],
      content: [''],

      video_src: [''],
      video_image: [''],

      meta_keywords: [''],
      meta_description: [''],

      pin: [0],
      visible: [1],

      add_date: [null],
      election_id: [null],
      subscribe_id: [null],

      list_status: [1],
      migrate_meetings: [null],

      gallery: this.fb.control([]),
      author: ['']
    });


  }

  onCheckboxChange(field: string, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.pageForm.patchValue({
      [field]: checked ? 1 : 0
    });
  }
  get allowedFiles(): string[] {
    const main = this.pageForm.get('main_image')?.value;
    const gallery = this.pageForm.get('gallery')?.value || [];
    return main ? [main, ...gallery] : [...gallery];
  }

  toggleFullscreen() {
    this.isFullscreen = !this.isFullscreen;

    const modal = document.querySelector('.custom-modal .modal-dialog');

    if (!modal) return;

    if (this.isFullscreen) {
      modal.classList.add('modal-fullscreen-custom');
    } else {
      modal.classList.remove('modal-fullscreen-custom');
    }
  }


  ngOnInit(): void {
    // console.log(this.initialData)

      if (this.initialData) {
        this.fillForm(this.initialData);
      }

      


    this.pageForm.get('title')?.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((title: string) => {
        if (title && !this.editingPageId) {
          const slug = slugify(title, { lower: true, strict: true });
          this.pageForm.get('slug')?.setValue(slug, { emitEvent: false });

          this.checkSlugAvailability(slug);
        }
      });

    this.pageForm.get('slug')?.valueChanges
    .pipe(
      debounceTime(500),
      distinctUntilChanged()
    )
    .subscribe(slug => this.checkSlugAvailability(slug));
    
  }

  private checkSlugAvailability(slug: string): void {
    // თუ არ შეცვლილა, გაასუფთავე შეცდომა და დაბრუნდი
    if (slug === this.originalSlug) {
      this.pageForm.get('slug')?.setErrors(null);
      return;
    }

    const source = this.pageForm.get('source')?.value || 'pages';

    this.PagesService.checkSlug(slug, source).subscribe({
      next: (res: any) => {
        if (!res.available) {
          this.pageForm.get('slug')?.setErrors({ slugTaken: true });
        } else {
          this.pageForm.get('slug')?.setErrors(null);
        }
      },
      error: () => {
        this.ToastrService.error('შეცდომა slug-ის შემოწმებისას');
      }
    });
  }

private fillForm(data: any) {
  console.log(data.add_date)
  this.pageForm.patchValue({
    lang: data.lang ?? 'geo',
    page: data.page ?? null,
    main_menu_page: data.main_menu_page ?? 0,
    menu_page: data.menu_page ?? 0,
    menu_id: data.menu_id ?? null,
    photogallery: data.photogallery ?? 0,
    only_gallery: data.only_gallery ?? 0,
    slug: data.slug ?? '',
    title: data.title ?? '',
    bold: data.bold ?? 0,
    content: this.addDomainToImageSrc(this.decodeHtml(data.content || '')),
    video_src: data.video_src ?? '',
    video_image: data.video_image ?? '',
    meta_keywords: data.meta_keywords ?? '',
    meta_description: data.meta_description ?? '',
    pin: data.pin ?? 0,
    visible: data.visible ?? 1,
    add_date: data.date ?? null,
    election_id: data.election_id ?? null,
    subscribe_id: data.subscribe_id ?? null,
    list_status: data.list_status ?? 1,
    migrate_meetings: data.migrate_meetings ?? null,
    gallery: data.gallery ?? [],
    author: data.author ?? null
  });

  this.originalSlug = data.slug ?? '';
  this.selectedImage = data.main_image ?? null;
  this.gallery = data.gallery ?? [];
  this.editingPageId = data.page ?? null;

  if (data.page) {
    this.getGallery(data.page);
  }
}


ngOnChanges(changes: SimpleChanges): void {
  console.log(111, this.initialData)
  if (changes['initialData'] && changes['initialData'].currentValue) {

    this.initialData = changes['initialData'].currentValue;

    console.log('ngOnChanges fired:', this.initialData);

    this.pageForm.patchValue({
      id: this.initialData.id ?? null,
      idx: this.initialData.idx ?? null,
      source: this.initialData.source ?? 'pages',
      title: this.initialData.title ?? '',
      menutitle: this.initialData.menutitle ?? '',
      menuid: this.initialData.menuid ?? 0,
      masterid: this.initialData.masterid ?? 0,
      content: this.addDomainToImageSrc(this.decodeHtml(this.initialData.content || '')),
      slug: this.initialData.slug ?? '',
      tmp: this.initialData.tmp ?? null,
      redirectlink: this.initialData.redirectlink ?? null,
      image1: this.initialData.image1 ?? '',
      postdate: this.initialData.postdate ?? '',
      youtube: this.initialData.youtube ?? '',
      meta_desc: this.initialData.meta_desc ?? '',
      meta_keys: this.initialData.meta_keys ?? '',
      visibility: this.initialData.visibility ?? 1,
      category: this.initialData.category ?? null,
      showinmenu: this.initialData.showinmenu ?? false,
      showinredirectlink: this.initialData.showinredirectlink ?? false,
      gallery: this.initialData.gallery ?? [],
      author: this.initialData.author ?? null,
    });

    this.originalSlug = this.initialData.slug ?? '';
    this.selectedImage = this.initialData.image || null;
    this.gallery = this.initialData.gallery || [];
    this.editingPageId = this.initialData.id ?? null;

    if (this.initialData.tmp === 'items' && this.initialData.source === 'pages') {
      this.pageForm.get('source')?.setValue('page-post');
    }

    if (this.initialData.id) {
      this.getGallery(this.initialData.id);
    }
  }

  if (!this.initialData && this.menuid) {
    this.pageForm.get('menuid')?.setValue(this.menuid);
  }
}
  getGallery(id: number) {
    this.PagesService.getGallery(id).subscribe(
      (res: any) => {
        if (Array.isArray(res)) {
          const galleryImages = res.map((img: any) => img.file); // ✅ მხოლოდ file-ები
          this.pageForm.patchValue({ gallery: galleryImages });
          this.gallery = galleryImages;
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }


   // ფაილების მოდალის გახსნა
  openFileManagerWrapper = (callback: (url: string) => void) => {
    this.filePickerCallback = callback;
    this.modalRef = this.modalService.open(this.fileManagerModal, {
      size: 'xl',
      windowClass: 'custom-filemanager-modal',
      fullscreen: true
    });
  };

  onFileSelectedFromManager(url: string, modal: any) {
    if (this.filePickerCallback) {
      this.filePickerCallback(url);
      this.filePickerCallback = null;
    } else {
      this.pageForm.patchValue({ image1: url });
    }
    modal.close();
  }

  openFileManagerForImage1() {

    this.modalService.open(this.fileManagerModal, {
      size: 'xl',
      windowClass: 'custom-filemanager-modal',
      fullscreen: true
    });

    this.filePickerCallback = (url: string) => {
      this.pageForm.patchValue({ image1: url });
      // modalRef.close();
    };
  }
onFilesSelected(files: string[]) {
  console.log('Selected files:', files);
  this.pageForm.get('gallery')?.setValue(files);
}


  onImageSelect(imageUrl: string) {
    this.selectedImage = imageUrl;
  }

  addToGallery(imageUrl: string) {
    if (!this.gallery.includes(imageUrl)) {
      this.gallery.push(imageUrl);
    }
  }

  removeFromGallery(imageUrl: string) {
    this.gallery = this.gallery.filter(img => img !== imageUrl);
  }

  removeGalleryImage(index: number) {
    this.gallery.splice(index, 1);
  }

  dropGalleryImage(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.gallery, event.previousIndex, event.currentIndex);
  }

  openFileManager() {
    // logic to open file manager and select image
    // after selection, call onImageSelect or addToGallery accordingly
  }

  onGalleryImagesSelected(images: string[]) {
    const current = this.pageForm.get('gallery')?.value || [];
    const merged = [...current, ...images.filter(img => !current.includes(img))];

    this.gallery = merged;
    this.pageForm.get('gallery')?.setValue(merged);
  }

   stripHtmlTags(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  addDomainToImageSrc(content: string): string {
    const domain = 'https://sca.ge';
    return content.replace(
      /<img([^>]+)src="(?!https?:\/\/|data:)([^"]+)"/g,
      (match, p1, p2) => {
        const fullSrc = p2.startsWith('/') ? `${domain}${p2}` : `${domain}/${p2}`;
        return `<img${p1}src="${fullSrc}"`;
      }
    );
  }

  decodeHtml(html: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  removeDomainFromImageSrc(content: string): string {
    return content.replace(/<img([^>]+)src="https?:\/\/[^\/]+(\/[^"]+)"/g, `<img$1src="$2"`);
  }


  openMetaFormModal() {
      const modalRef = this.modalService.open(MetaFormModalComponent, {
        size: 'md'
      });
  
      modalRef.componentInstance.meta_desc = this.pageForm.get('meta_desc')?.value || '';
      modalRef.componentInstance.meta_keys = this.pageForm.get('meta_keys')?.value || '';
  
      modalRef.componentInstance.save.subscribe((data: any) => {
        this.pageForm.patchValue({
          meta_desc: data.meta_desc,
          meta_keys: data.meta_keys
        });
        modalRef.close();
      });
  }


  savePage() {
    if (
      this.pageForm.get('source')?.value === 'catalogs' ||
      this.pageForm.get('slug')?.value === 'news' ||
      this.pageForm.get('source')?.value === 'page-post'
    ) {
      this.pageForm.get('tmp')?.setValue('items');
    } else {
      this.pageForm.get('tmp')?.setValue('');
    }

    if(this.pageForm.get('source')?.value === 'page-post'){
      this.pageForm.get('source')?.setValue('pages');
      this.pageForm.get('tmp')?.setValue('items');
    }

    let user = this.AdminService.user.name + ' ' + this.AdminService.user.lastname
    this.pageForm.get('author')?.setValue(user);

    const payload = {
      ...this.pageForm.value,
      language: this.currentLang
    };

    this.loadSave = true;

    const finalize = () => {
      this.save.emit();
      if (this.modalRef) {
        this.modalRef.close();
      }
      this.loadSave = false;
    };

      if(this.isPost){
        
        this.pageForm.get('menuid').setValue(this.menuid)
      }

    if (!this.editingPageId) {
      this.PagesService.createPage(payload).subscribe({
        next: () => {
          this.ToastrService.success('გვერდი დაემატა წარმატებით');
          finalize();
        },
        error: (error: any) => {
          this.ToastrService.error('შეცდომა დამატებისას');
          this.loadSave = false;

        }
      });
    } else {
      this.PagesService.updatePage(payload).subscribe({
        next: () => {
          this.ToastrService.success('გვერდი წარმატებით განახლდა');
          finalize();
        },
        error: () => {
          this.ToastrService.error('შეცდომა შენახვისას');
          this.loadSave = false;
        }
      });
    }
  }


  getFullImageUrl(imagePath: string): string {
    if (!imagePath) return '';

    // თუ უკვე სრული URL არის — 그대로 დააბრუნე
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      return imagePath;
    }

    const cleanPath = imagePath.replace(/^\/+/, '');

    // ✅ ძველი საიტის storage / res/images ლოგიკა
    // მაგალითად: "res/images/images/4G3A8409.JPG"
    if (cleanPath.startsWith('res/images')) {
      const oldDomain = 'https://sca.ge/'; // შეცვალე რეალურ ძველ დომენზე
      return `${oldDomain}${cleanPath}`;
    }

    // ✅ ახალი ლარაველის storage ლოგიკა
    // მაგალითად: "storage/images/xxx.jpg"
    return `${this.domain}/${cleanPath}`;
  }


}
